// Auto-generated by scripts/generateFactionSkinConfig.mjs
// Do not edit manually.

// eslint-disable-next-line no-unused-vars
import {FACTIONS} from '../../../constants/factions';
// eslint-disable-next-line no-unused-vars
import {PLAYER_COLORS} from '../../colors';

export const FACTION_SKINS_ELVES = [{
  id: 'elves_wood',
  factionId: FACTIONS.ELVES,
  name: 'Лесной Рейнджер',
  priceNumens: 6000,
  skinRank: 1,
}, {
  id: 'elves_north',
  factionId: FACTIONS.ELVES,
  name: 'Память Севера',
  priceNumens: 45000,
  skinRank: 2,
  colors: [
    PLAYER_COLORS.CELADON,
    PLAYER_COLORS.SKY_BLUE,
    PLAYER_COLORS.BLUE,
  ]
}, {
  id: 'elves_crossbow',
  factionId: FACTIONS.ELVES,
  name: 'Бритва',
  priceNumens: 100000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.ORANGE
  ]
}, {
  id: 'elves_gold_legacy',
  factionId: FACTIONS.ELVES,
  name: 'Страж долины',
  priceNumens: 80000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.YELLOW,
  ],
  excludedFromChests: true
}, {
  id: 'elves_ruby_legacy',
  factionId: FACTIONS.ELVES,
  name: 'Королевский стрелок',
  priceCrystals: 400,
  skinRank: 4,
  colors: [
    PLAYER_COLORS.PINK,
    PLAYER_COLORS.RED,
  ],
  accentColor: PLAYER_COLORS.RED,
  excludedFromChests: true
}];
